import React from "react";
import {getGeoCoder, getUserCurrentLocation} from "./mapUtils";
import {defaultLatitude, packetStatus, defaultLongitude, MessageType} from "../../../Constant";
import "./mapWrapper.css";
import {MapComponent} from "./mapComponent";
import { googleProperties } from "../../../services/login/properties";
import { LoadScript } from "@react-google-maps/api";
import PropTypes from "prop-types";

export class MapWrapperComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            center: props.center,
            data: props.data,
            googleMapsLoaded : false,
        };

    }

    componentDidMount() {
        this.mounted = true;
        this.updateCurrentLocationInState();
        let lat = parseFloat(this.props.data.latitude);
        let lng = parseFloat(this.props.data.longitude);
        if (this.props.data.packetStatus && this.props.data.packetStatus == packetStatus.VALID)
            this.updateAddress(lat, lng, null, null);
        else
            this.updateAddress(lat, lng, null, null);

        if(this.state.googleMapsLoaded){
            this.updateAddress(lat, lng, null, null);
        }
    }

    updateCurrentLocationInState() {
        getUserCurrentLocation().then(pos=> {
            if (this.mounted) {
                this.setState({
                    currentLocation: pos
                });
                if (this.props.defaultCurrentLocation) {
                    this.setState({
                        center: pos,
                    })
                }
            }
        }).catch((err)=> {
                console.error('err', err);
                if (this.props.onMessage)
                    this.props.onMessage({type: MessageType.ERROR, message: "Unable to fetch user's location"});
            }
        );
    }

    componentDidUpdate(prevProps) {
        const { data, center, onMessage } = this.props;

        // Handle data update
        if (prevProps.data !== data) {
            this.setState({ data });

            const lat = parseFloat(data?.latitude);
            const lng = parseFloat(data?.longitude);
            const prevLat = parseFloat(prevProps.data?.latitude);
            const prevLng = parseFloat(prevProps.data?.longitude);

            this.updateAddress(lat, lng, prevLat, prevLng);
        }

        // Handle center update
        if (prevProps.center !== center) {
            const hasValidCenter = center?.lat && center?.lng;

            if (hasValidCenter) {
            this.setState({ center });
            return;
            }

            if (onMessage) {
            onMessage({
                type: MessageType.ERROR,
                message: "Device's location can't be located",
            });
            }

            this.setState(prevState => {
            const fallbackCenter = prevState.currentLocation
                ? { ...prevState.currentLocation }
                : {
                    lat: defaultLatitude,
                    lng: defaultLongitude,
                };

            return { center: fallbackCenter };
            });
        }
        }




    updateAddress(lat, lng, prevLat, prevLng) {
        if (lat && lat != prevLat && lng && lng != prevLng) {
            this.getLocation({
                lat: lat,
                lng: lng
            })
        }
    }

    render() {
        const hideRecenter = !(parseFloat(this.props.data.latitude));
        return <div className="map-wrapper-component">
            { this.state.currentLocation &&
            <div className="re-center-button" onClick={()=> {
                this.setState((prevState)=> {
                        return {
                            center: {... prevState.currentLocation}
                        }
                    }
                )
            }}>
                <span className="span-icon current-icon"/>
            </div>}
            { !hideRecenter &&
            <div className={this.state.currentLocation ? "re-center-button re-locate" : "re-center-button"}
                 onClick={()=> {
                     this.setState((prevState)=> {
                             return {
                                 center: {
                                     lat: parseFloat(prevState.data.latitude),
                                     lng: parseFloat(prevState.data.longitude)
                                 }
                             }
                         }
                     )
                 }}>
                <span className="span-icon recenter-icon"/>
            </div>}

                <LoadScript
                googleMapsApiKey={googleProperties.map.api_key}
                onLoad={() => {
                    this.setState({ googleMapsLoaded: true }, () => {
                        // Now safe to geocode!
                        const { latitude, longitude } = this.props.data;
                        const lat = parseFloat(latitude);
                        const lng = parseFloat(longitude);
                        this.updateAddress(lat, lng, null, null);
                    });
                }}
                >
                 {this.state.googleMapsLoaded && 
                    <MapComponent
                        isMarkerShown={true}
                        data={this.props.data}
                        address={this.state.address}
                        center={this.state.center}
                        icon={this.props.icon}
                    />
                    }
            </LoadScript>

        </div>
    }

getLocation(latlng) {
  getGeoCoder().then(geocoder => {
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK') {
        if (results[1]) {
          this.setState({ address: results[1].formatted_address });
        } else {
          this.setState({ address: "Not found" });
        }
      } else {
        this.setState({ address: "ERROR_OCCURRED_WHILE_FETCHING" });
      }
    });
  }).catch((err) => {
    this.setState({ address: "ERROR_OCCURRED_WHILE_FETCHING" });
    console.error(err);
  });
}

    componentWillUnmount() {
        this.mounted = false;
    }

}


MapWrapperComponent.propTypes = {
  center: PropTypes.object,
  data: PropTypes.shape({
    latitude: PropTypes.any,
    longitude: PropTypes.any,
    packetStatus: PropTypes.any,
  }),
  defaultCurrentLocation: PropTypes.bool,
  onMessage: PropTypes.func,
  icon: PropTypes.any,
};